<script>
import appConfig from '@src/app.config.json'
import Layout from '@layouts/user-management.vue'
import { hasErrors } from '@utils/form'
import { httpServices } from '@utils/http-services'
import { features } from '@utils/features.const'

export default {
  page: {
    title: 'Create Organization',
    meta: [{ name: 'description', content: appConfig.description }],
  },
  components: { Layout },
  data() {
    return {
      showOrg: this.$auth.user.profile.permissions.organization === 'vanished',
      hasErrors,
      org: null,
      features: features,
      formLayout: 'horizontal',
      form: this.$form.createForm(this, { name: 'coordinated' }),
    }
  },
  mounted() {},
  methods: {
    handleSubmit(e) {
      e.preventDefault()
      this.form.validateFields((err, values) => {
        if (!err) {
          const data = {
            orgId: values.name,
            permissions: {
              features: values.features || [],
            },
            meta: {
              name: values.name,
              address: values.address,
              license: values.license,
            },
          }
          httpServices.createOrganization(data).then(
            (res) => {
              this.$notification.success({
                message: `${
                  res?.data?.meta?.name || 'Org'
                } Successfully Created`,
              })
              this.$router.push({
                name: 'user-management',
              })
            },
            () => {
              this.$notification.error({
                message: 'Failed to Create Org: That ID already exists.',
              })
            }
          )
        }
      })
    },
  },
}
</script>

<template>
  <Layout>
    <div v-if="showOrg" class="ant-row profile--container">
      <div class="breadcrumb--container">
        <a-breadcrumb>
          <a-breadcrumb-item href="#">
            <router-link to="/">
              <a-icon type="home" />
            </router-link>
          </a-breadcrumb-item>
          <a-breadcrumb-item href="#">
            <router-link to="/user-management">
              <a-icon type="team" />
              <span>User Management</span>
            </router-link>
          </a-breadcrumb-item>
          <a-breadcrumb-item>
            <a-icon type="plus-square" />
            Add New Organization
          </a-breadcrumb-item>
        </a-breadcrumb>
      </div>
      <div class="form-container">
        <div
          class="header"
          style="
            padding: 1.2rem;
            margin-bottom: 0;
            text-align: center;
            background: #141414;
            border-radius: 4px 4px 0 0;
          "
        >
          <h4 style="margin: 0; font-weight: 100; color: #fff">
            <a-icon type="plus-square" style="padding-right: 4px" />
            Add New Organization
          </h4>
        </div>

        <template>
          <a-card>
            <a-tabs default-active-key="1">
              <a-tab-pane key="1" tab="Organization Meta Data">
                <a-card style="width: 100%">
                  <a-form :form="form" @submit="handleSubmit">
                    <a-row>
                      <a-col :sm="16" :md="12">
                        <a-form-item label="Name">
                          <a-input
                            v-decorator="[
                              'name',
                              {
                                rules: [
                                  {
                                    required: true,
                                    placeholder: 'Please input your name!',
                                  },
                                ],
                              },
                            ]"
                          />
                        </a-form-item>
                      </a-col>
                      <a-col :sm="16" :md="12">
                        <a-form-item label="Address">
                          <a-input
                            v-decorator="[
                              'address',
                              {
                                rules: [
                                  {
                                    required: true,
                                    placeholder: 'Please input your address!',
                                  },
                                ],
                              },
                            ]"
                          />
                        </a-form-item>
                      </a-col>

                      <a-col :sm="16" :md="12">
                        <a-form-item label="License">
                          <a-input
                            v-decorator="[
                              'license',
                              {
                                rules: [
                                  {
                                    required: true,
                                    placeholder: 'Please input your license!',
                                  },
                                ],
                              },
                            ]"
                          />
                        </a-form-item>
                      </a-col>

                      <a-col :sm="16" :md="12">
                        <a-form-item label="Features">
                          <a-select v-decorator="['features']" mode="multiple">
                            <a-select-option
                              v-for="(f, i) in features"
                              :key="i"
                              :value="f.id"
                            >
                              {{ f.name }}
                            </a-select-option>
                          </a-select>
                        </a-form-item>
                      </a-col>
                    </a-row>

                    <a-row>
                      <a-form-item :wrapper-col="{ span: 12 }">
                        <a-button
                          type="primary"
                          html-type="submit"
                          :disabled="hasErrors(form.getFieldsError())"
                        >
                          Save
                        </a-button>
                      </a-form-item>
                    </a-row>
                  </a-form>
                </a-card>
              </a-tab-pane>
            </a-tabs>
          </a-card>
        </template>
      </div>
    </div>
    <div v-else>
      <h1>403: Unauthorized</h1>
    </div>
  </Layout>
</template>
